export const getDictionariesColumns = ({ dictionaryColumns }) =>
  dictionaryColumns.list.data.items;

export const getIsAdding = ({ dictionaryColumns }) =>
  dictionaryColumns.add.isLoading;

export const getIsUpdating = ({ dictionaryColumns }) =>
  dictionaryColumns.update.isLoading;

export const getIsDeleting = ({ dictionaryColumns }) =>
  dictionaryColumns.delete.isLoading;
